import { Component, OnInit, OnDestroy } from '@angular/core';
import { Configuration } from '../models/configuration';
import { ConfigurationService } from '../services/configuration.service';
import { Alert, AlertType } from '../../shared/alert.model';
import { MessageService } from '../../shared/message.service';
import { Subscription } from 'rxjs';
import { MessageType } from '../../shared/messageType';
import { getAlertMessage } from '../../shared/api-loaders';

@Component({
    selector: 're-configuration-list',
    templateUrl: './configuration-list.component.html',
    styleUrls: ['./configuration-list.component.scss'],
    standalone: false
})
export class ConfigurationListComponent implements OnInit, OnDestroy{


  configurations: Configuration[];
  loading: boolean;
  alert: Alert;
  messageSubscription: Subscription;

  constructor(private configurationService: ConfigurationService, private messageService: MessageService) {
    this.messageSubscription = this.messageService.get().subscribe(message => {
      if (message.type == MessageType.ConfigurationCreated) {
        this.alert = { type: AlertType.SUCCESS, message: `Configuration ${message.data} has been created successfully` };
        this.clearAlerts();
      }
    })
  }
  clearAlerts() {
    setTimeout(() => this.alert = null, 5000);
  }
  ngOnDestroy(): void {
    this.messageSubscription.unsubscribe();
    }
  ngOnInit() {
    this.getConfigurations();
  }

  getConfigurations(): void {
    this.loading = true;
    this.configurationService.getConfigurationsByStack()
      .subscribe(configurations => { this.configurations = configurations; this.loading = false; },
        error => {
          this.alert = getAlertMessage(error);
          this.loading = false;
        });
  }

}
